<template>
<div :class="$style['apply-refund-message']">
    <div :class="$style['refund-message-basic']">
    <table>
        <tr>
            <td>{{titleLable}}方式：</td>
            <td>{{orderDetail.refundmentType}}</td>
        </tr>
        <tr>
            <td>{{titleLable}}状态：</td>
            <td>{{orderDetail.orderRefundStatus}}</td>
        </tr>
         <tr>
            <td>收货状态：</td>
            <td>{{orderDetail.is_got}}</td>
        </tr>
         <tr>
            <td>申请{{titleLable}}时间：</td>
            <td>{{orderDetail.applyTime}}</td>
        </tr>
         <tr>
            <td>申请{{titleLable}}金额：</td>
            <td v-if="title">{{orderDetail.refund_amount&&"¥"+orderDetail.refund_amount}}</td>
            <td v-else>{{orderDetail.refund_points}}</td>
        </tr>
        <!-- <tr>
            <td>实际审批金额：</td>
            <td>{{orderDetail.refunded_amount&&"¥"+orderDetail.refunded_amount}}</td>
        </tr> -->
        <tr>
            <td>{{titleLable}}原因：</td>
            <td>{{apply.reasonDescription}}</td>
        </tr>
        <tr>
            <td>{{titleLable}}说明：</td>
            <td>{{apply.remark}}</td>
        </tr>
        <tr v-if="title">
            <td>取消实验室订单：</td>
            <td>{{orderDetail.refund_sampleId}}</td>
        </tr>
        <tr  v-if="apply.credential">
            <td>相关凭证：</td>
            <td><img @click="onPreview(apply.credential)" :src="privateResourcesUrl+apply.credential"/></td>
        </tr>
    </table>
    <div class="button-div" v-if="isApproveButton||refundAppleAgain">
        <template v-if="isApproveButton">
            <el-button type="primary"  @click="approve_refund">审核通过</el-button>
            <el-button type="primary" plain @click="return_refund">驳回</el-button>
        </template>
        <template v-if="refundAppleAgain">
        <el-button type="primary" @click="getRefundAppleAgain">再次申请</el-button>
        </template>
    </div>
    </div>
    <div>
        <table>
            <tr v-if="apply.courierName">
                <td>快递公司：</td>
                <td>{{apply.courierName}}</td>
            </tr>
            <tr v-if="apply.courierNumber">
                <td>快递单号：</td>
                <td :class="$style['courier-message']">{{apply.courierNumber}}</td>
            </tr>
            <template v-if="hasApprove">
            <template v-if="isRejected">
            <tr>
                <td>{{titleLable}}驳回时间：</td>
                <td>{{orderDetail.rejectTime}}</td>
            </tr>
            <tr>
                <td>{{titleLable}}驳回理由：</td>
                <td>{{orderDetail.refundmentDetails.rejectRemark}}</td>
            </tr>
            </template>
            <template v-else-if="isApprovePass">
                <tr>
                    <td>{{titleLable}}审批时间：</td>
                    <td>{{orderDetail.REFUND_APPROVED_time}}</td>
                </tr>
                 <tr v-if="isCompleted">
                    <td>{{titleLable}}完成时间：</td>
                    <td>{{orderDetail.REFUND_COMPLETED_time}}</td>
                </tr>
                <tr v-else-if="isFaild">
                    <td>{{titleLable}}失败时间：</td>
                    <td>{{orderDetail.REFUND_FAILED_time}}</td>
                </tr>
            </template>
            </template>
            <tr>
                <td>{{titleLable}}途径：</td>
                <td v-if="title">{{orderDetail.refundProcessMode||'--'}}</td>
                <td v-else>系统退还</td>
            </tr>
        <tr>
            <td>{{titleLable}}流水号：</td>
            <td v-if="title">{{refundmentDetails.refundPayNumber?refundmentDetails.refundPayNumber:'--'}}</td>
            <td v-else>{{refundmentDetails.refundOrderNumber?refundmentDetails.refundOrderNumber:'--'}}</td>
        </tr>
        </table>
    </div>
        <table>
        <tr v-if="orderDetail.refundmentDetails&&orderDetail.refundmentDetails.status==='REFUND_FAILED'">
          <td>退款失败原因：</td>
          <td class="reject-faild-remark">{{orderDetail.refundmentDetails.rejectFailedRemark}}</td>
        </tr>
        </table>
    <el-dialog :visible="is_dialog" :title="dialog_title" :class="$style['refund-dialog']" @close="dialogClose">
        <execute-refundment v-if="is_approve_refund" :orderDetail="orderDetail" @close="closeDialog" :isIntegralRefund="!title"></execute-refundment>
        <turn-down v-if="is_return" :orderDetail="orderDetail" @close="closeDialog" :isIntegralRefund="!title"></turn-down>
    </el-dialog>
     <wt-image-preview v-if="previewVisible" @close-preview="closePreview" :value="images" :initial-index="currentIndex" :loop="false"></wt-image-preview>
</div>
</template>
<script>
import executeRefundment from '../pt-refund-order-list/execute-refundment'
import turnDown from '../pt-refund-order-list/turn-down'
import { hasPermissions } from 'utils/permissions'
// 订单退款审批权限
const PERM_MALLSALES_ORDER_REFUND_APPROVAL = 'PERM_MALLSALES_ORDER_REFUND_APPROVAL'
export default {
  props: {
    orderDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    refundmentDetails: {
      type: Object,
      default: function () {
        return {}
      }
    },
    // true 文字为退款  false 为退还积分
    title: {
      type: Boolean,
      default: true
    },
    // 申请退款权限
    HAS_ORDER_MANAGEMENT: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      privateResourcesUrl: this.$privateResourcesUrl,
      is_approve_refund: false,
      is_return: false,
      dialog_title: '',
      previewVisible: false,
      currentIndex: 1,
      privateImg: this.$publicResourcesUrl,
      images: ''
    }
  },
  computed: {
    titleLable () {
      return this.title ? '退款' : '退还积分'
    },
    apply () {
      return this.refundmentDetails.apply || {}
    },
    is_dialog: {
      get: function () {
        return this.is_approve_refund || this.is_return
      },
      set: function (val) {
        this.is_approve_refund = val
        this.is_return = val
      }
    },
    // 是否有退款信息
    hasApprove () {
      return this.orderDetail.refundmentDetails
    },
    // 是否有驳回信息
    isRejected () {
      return this.hasApprove && this.orderDetail.refundmentDetails.status === 'REFUND_REJECTED'
    },
    // 是否退款是否已完成
    isCompleted () {
      return this.hasApprove && this.orderDetail.refundmentDetails.status === 'REFUND_COMPLETED'
    },
    // 是否退款失败
    isFaild () {
      return this.hasApprove && this.orderDetail.refundmentDetails.status === 'REFUND_FAILED'
    },
    // 是否经过了审批通过步骤
    isApprovePass () {
      return this.hasApprove && (this.hasApprove.status === 'REFUND_APPROVED' || this.isFaild || this.isCompleted)
    },
    // 审批退款权限
    HAS_REFUND_APPROVAL () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_MALLSALES_ORDER_REFUND_APPROVAL)
    },
    // 是否显示审核按钮
    isApproveButton () {
      return (this.hasApprove && this.orderDetail.refundmentDetails.status === 'SUBMITTED' && this.HAS_REFUND_APPROVAL) || (this.hasApprove && this.orderDetail.refundmentDetails.status === 'COMMIT' && this.HAS_REFUND_APPROVAL)
    },
    // 是否显示再次申请的按钮
    refundAppleAgain () {
      return this.orderDetail.refundmentDetails && (this.orderDetail.refundmentDetails.status === 'REFUND_REJECTED' || this.orderDetail.refundmentDetails.status === 'REFUND_FAILED' ||
      this.orderDetail.refundmentDetails.status === 'REFUND_TIMEOUT') && (this.HAS_ORDER_MANAGEMENT || this.HAS_REFUND_APPROVAL)
    }
  },
  components: {
    executeRefundment,
    turnDown
  },
  methods: {
    onPreview (img) {
      this.images = this.privateResourcesUrl + img
      this.previewVisible = true
    },
    closePreview () {
      this.previewVisible = false
    },
    getRefundAppleAgain () {
      this.$emit('refundAppleAgain')
    },
    approve_refund () {
      this.is_approve_refund = true
      this.dialog_title = this.title ? '订单退款' : '订单退还积分'
    },
    dialogClose () {
      this.is_approve_refund = false
      this.is_return = false
    },
    closeDialog (val) {
      if (val) {
        this.$emit('refreshDetail')
      }
      this.is_approve_refund = false
      this.is_return = false
    },
    return_refund () {
      this.is_return = true
      this.dialog_title = this.title ? '退款驳回' : '积分退还驳回'
    }
  }
}
</script>
<style module lang="less">
@import "~less/var.less";
.apply-refund-message{
    padding:0 20px;
    display: flex;
    flex-direction: row;
    :global
    table{
        tr{
            td{
                line-height: 30px;
                font-size: 14px;
                img{
                    max-width: 60px;
                    height: auto
                }
            }
            :first-child{
                display: flex;
                color:@mainColor;
                justify-content: flex-end;
            }
            .reject-faild-remark{
              color: red;
              max-width: 240px;
            }
        }
    }
}
.refund-message-basic{
    width: 50%
}
.refund-dialog{
    :global
    .el-dialog{
        width: 30%;
        margin: 0!important;
        max-width:500PX;
        min-width: 450PX;
        .el-dialog__body{
            padding: 10px 20px 25px;
        }
    }
}
.courier-message{
    margin-bottom: 20px
}
</style>
